import React from 'react';

interface PlaceholderPageProps {
  title: string;
  icon: string;
  description?: string;
}

function PlaceholderPage({ title, icon, description }: PlaceholderPageProps): React.ReactElement {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="relative min-h-[300px] flex items-center justify-center overflow-hidden py-20 px-6">
        <div className="absolute inset-0 bg-gradient-to-br from-gray-800 via-gray-900 to-slate-900"></div>
        <div className="absolute inset-0 opacity-40 bg-[radial-gradient(circle_at_25%_25%,rgba(124,58,237,0.3)_0%,transparent_50%),radial-gradient(circle_at_75%_75%,rgba(236,72,153,0.3)_0%,transparent_50%)]"></div>
        <div className="relative z-10 max-w-[1400px] mx-auto text-center">
          <span className="text-6xl mb-6 block">{icon}</span>
          <h1 className="font-display text-5xl font-extrabold text-white mb-4">{title}</h1>
          <p className="text-lg text-gray-300 max-w-xl mx-auto leading-relaxed">{description || `The ${title} page is coming soon. Check back later for updates.`}</p>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto px-6 py-12">
        <div className="bg-white rounded-2xl p-12 text-center shadow-[0_1px_3px_rgba(0,0,0,0.05)]">
          <div className="text-5xl mb-4">🚧</div>
          <h2 className="font-display text-2xl font-bold text-gray-900 mb-2">Under Construction</h2>
          <p className="text-gray-500">We're working hard to bring you this content. Stay tuned!</p>
        </div>
      </div>
    </div>
  );
}


export function DocumentsPage(): React.ReactElement {
  return <PlaceholderPage title="Documents" icon="📄" description="Access shared documents, templates, and file storage." />;
}

export function ResourcesPage(): React.ReactElement {
  return <PlaceholderPage title="Resources" icon="📚" description="Find helpful resources, guides, and reference materials." />;
}

export default PlaceholderPage;
